import { errors } from "../constants";
import {
  createErrorResult,
  IIncidentCloseResponse,
  ILiveMapIncidentItem,
  SimpleResult,
} from "../dto";
import { Api, getCompanyId } from "../helpers";
import type { IIncidentByRideListRowDto } from "../models/live-map";

export interface IIncidentsByRideBody {
  rideId: number;
}

export class IncidentsApi {
  static async fetchLiveMapNewIncidents(
    rideIds: readonly number[],
    abortController?: AbortController,
  ): Promise<SimpleResult<ILiveMapIncidentItem[]> | undefined> {
    const companyId = getCompanyId();
    const ids = [...new Set(rideIds)].filter(id => id > 0);

    if (!ids.length) {
      return createErrorResult<ILiveMapIncidentItem[]>(
        errors.ride.invalidRideId,
      );
    }

    const requestUrl = `/api/v1/core/c/${companyId}/incidents/live-map-incidents`;
    const response = await Api.post<SimpleResult<ILiveMapIncidentItem[]>>(
      requestUrl,
      { rideIds: ids },
      abortController,
    );

    return response?.data;
  }

  static async fetchIncidentsByRide(
    body: IIncidentsByRideBody,
    abortController?: AbortController,
  ): Promise<SimpleResult<IIncidentByRideListRowDto[]> | undefined> {
    const companyId = getCompanyId();

    if (!body.rideId) {
      return createErrorResult<IIncidentByRideListRowDto[]>(
        errors.ride.invalidRideId,
      );
    }

    const requestUrl = `/api/v1/core/c/${companyId}/incidents/incidents-by-ride`;
    const response = await Api.post<SimpleResult<IIncidentByRideListRowDto[]>>(
      requestUrl,
      body,
      abortController,
    );

    return response?.data;
  }

  static async closeIncident(
    incidentId: number,
    abortController?: AbortController,
  ): Promise<SimpleResult<IIncidentCloseResponse> | undefined> {
    const companyId = getCompanyId();

    if (!incidentId) {
      return createErrorResult<IIncidentCloseResponse>(
        errors.common.emptyApiResponse,
      );
    }

    const requestUrl = `/api/v1/core/c/${companyId}/incidents/close-incident`;
    const response = await Api.post<SimpleResult<IIncidentCloseResponse>>(
      requestUrl,
      { id: incidentId },
      abortController,
    );

    return response?.data;
  }
}
